import React from 'react';

const Button = (props) => {
    return (
        <button
            type={props.type ?? 'submit'}
            className={props.className}
            disabled={props.disabled}
        >
            {props.title}
        </button>
    );
};

export default Button;